"use strict";

var currentReview = 0;
var reviews;
var reviewInterval; // Variable to hold the interval reference

document.addEventListener("DOMContentLoaded", function () {
  var reviewContainer = document.querySelector(".review-container");
  if (!reviewContainer) {
    return;
  }
  reviews = document.querySelectorAll(".review-item");
  function calculateMaxHeight() {
    var maxHeight = 0;
    reviews.forEach(function (review) {
      review.style.display = "block"; // Temporarily display all reviews
      var reviewHeight = review.offsetHeight;
      if (reviewHeight > maxHeight) {
        maxHeight = reviewHeight;
      }
      review.style.display = ""; // Reset display style
    });
    reviewContainer.style.height = "".concat(maxHeight + 50, "px");
  }

  // Calculate the max height on load
  calculateMaxHeight();

  // Start the automatic review change
  startReviewInterval();
  showReview(currentReview); // Show the first review initially

  // Recalculate max height on window resize
  window.addEventListener("resize", calculateMaxHeight);
});
function startReviewInterval() {
  reviewInterval = setInterval(function () {
    currentReview = (currentReview + 1) % reviews.length;
    showReview(currentReview);
  }, 5000);
}
function resetReviewInterval() {
  clearInterval(reviewInterval); // Clear the existing interval
  startReviewInterval(); // Start a new interval
}
function reviewsScrollPrev() {
  currentReview = (currentReview - 1 + reviews.length) % reviews.length; // Ensure currentReview doesn't go negative
  showReview(currentReview);
  resetReviewInterval(); // Reset the timer
}
function reviewsScrollNext() {
  currentReview = (currentReview + 1) % reviews.length;
  showReview(currentReview);
  resetReviewInterval(); // Reset the timer
}
function showReview(index) {
  reviews.forEach(function (review, i) {
    if (i === index) {
      review.classList.add("active");
    } else {
      review.classList.remove("active");
    }
  });
}
//# sourceMappingURL=reviewsScroll.js.map